export default function convertRegexToJsonSchemaString(regex: RegExp): string {
    const regexString = regex.toString();
    return regexString.substr(1, regexString.length - 2);
}
